import { cloneDeep } from "lodash";

// Const
import { organizationType } from "const/nuclias/organization";
import { defaultSelectAllItem } from "./const";

// Service
import AuthOrganizationService from "services/Auth.Organization.service";

// Model
import SmsConfigModel from "./models/SmsConfig";

const getSmsConfig = async (orgId) => {
  const response = await AuthOrganizationService.getSmsConfig(orgId);
  return response;
}

const parseRawData = (rawDataList, orgTreeMap, selectedOrg) => {
  const list = [];

  for (const rawData of rawDataList) {
    list.push(new SmsConfigModel(rawData, orgTreeMap, selectedOrg));
  }

  return list;
}

const getDefaultSiteTagList = (hasAll, managedSiteTagList, selectedSmsConfig) => {
  const list = [];

  if (hasAll) {
    list.push(defaultSelectAllItem);

    for (const { id, name } of managedSiteTagList) {
      list.push({
        id,
        title: name,
        type: organizationType.tag,
        isActive: false
      })
    }

    list[0].isActive = true;
  } else {
    for (const { id, name } of managedSiteTagList) {
      list.push({
        id,
        title: name,
        type: organizationType.tag,
        isActive: selectedSmsConfig?.rawData.storeTagId === id ? true : false
      })
    }

    (list.length > 0 && !selectedSmsConfig) && (list[0].isActive = true);
  }

  return list;
}

const getDefaultSiteList = (hasAll, managedSiteList, selectedSmsConfig) => {
  const list = [];

  if (hasAll) {
    list.push(defaultSelectAllItem);

    for (const { id, name } of managedSiteList) {
      list.push({
        id,
        title: name,
        type: organizationType.site,
        isActive: false
      })
    }

    list[0].isActive = true;
  } else {
    for (const { id, name } of managedSiteList) {
      list.push({
        id,
        title: name,
        type: organizationType.site,
        isActive: selectedSmsConfig?.rawData.storeId === id ? true : false
      })
    }

    (list.length > 0 && !selectedSmsConfig) && (list[0].isActive = true);
  }

  return list;
}

const addOrSaveSmsConfig = async (orgId, selectedSmsConfigId, smsConfigState) => {
  const payload = {
    name: smsConfigState.name.value,
    twilioClientId: smsConfigState.twilioAccountSid.value,
    twilioSecretId: smsConfigState.twilioAuthToken.value,
    twilioFromNumber: smsConfigState.twilioFromNumber.value,
    smsResendAfter: smsConfigState.resendAfter.value,
    smsResendNumber: smsConfigState.maximumResend.value,
    smsRequestNumber: smsConfigState.maximumRequest.value,
    smsDenialPeriod: smsConfigState.denialPeriod.value,
    smsExpiresIn: smsConfigState.otpExpiresIn.value,
    smsAllowedPhonePrefix: smsConfigState.allowedPhonePrefix.value.split(',')
  };

  if (smsConfigState.siteTagOrSite.value?.type === organizationType.tag) {
    payload['storeTagId'] = smsConfigState.siteTagOrSite.value.id;
  }

  if (smsConfigState.siteTagOrSite.value?.type === organizationType.site) {
    payload['storeId'] = smsConfigState.siteTagOrSite.value.id;
  }

  const response = await AuthOrganizationService.addOrUpdateSmsConfig(orgId, selectedSmsConfigId, payload);

  return response;
}

const saveName = async (orgId, smsConfig) => {
  const payload = cloneDeep(smsConfig.rawData);
  payload.name = smsConfig.name;

  const response = await AuthOrganizationService.addOrUpdateSmsConfig(orgId, smsConfig.id, payload);

  return response;
}

const deleteSmsConfig = async (orgId, idList) => {
  const payload = { ids: idList };
  const response = await AuthOrganizationService.deleteSmsConfig(orgId, payload);

  return response;
}

export default {
  getSmsConfig,
  parseRawData,
  getDefaultSiteTagList,
  getDefaultSiteList,
  addOrSaveSmsConfig,
  saveName,
  deleteSmsConfig
};
